var r=(e=>(e.none="",e.xs="xs",e.s="s",e.m="m",e.l="l",e.xl="xl",e.custom="custom",e))(r||{}),l=(t=>(t.left="left",t.center="center",t.right="right",t))(l||{});export{r as a,l as b};
//# sourceMappingURL=ninox-components-CRUPOILO.js.map